
    import { initApp } from "./main";
    initApp("#app");
  